import { Component, Input } from '@angular/core';
import { formatDate } from '@proximus/common-utils';
import { LanguageService } from '@proximus/ng-common';

@Component({
  selector: 'mprd-date-formatter',
  templateUrl: './date-formatter.component.html',
})
export class DateFormatterComponent {
  @Input() date: number | Date;
  @Input() selectedFormat: string;

  constructor(public languageService: LanguageService) {}

  format(): string {
    return formatDate(
      this.date,
      this.selectedFormat,
      this.languageService.getSelectedLanguage(),
    );
  }
}
